module.exports = __webpack_public_path__ + "img/squiggle.7a99b033.svg";